export const BASE_URL='https://backend.biometricpro.app/api/'
// export const BASE_URL='http://localhost:3050/api/'